/**
 * @file Shared React component — components/common/StatCard.tsx.
 */

import React from "react";
import "./StatCard.css";

interface StatCardProps {
  /** Icon element (SVG or emoji) - optional */
  icon?: React.ReactNode;
  /** Main value to display */
  value: string | number;
  /** Label text */
  label: string;
  /** Optional highlight style */
  highlight?: boolean;
  /** Optional click handler */
  onClick?: () => void;
}

/**
 * Reusable Stat Card component for displaying statistics
 * Used across dashboard pages for consistent statistics display
 */
const StatCard: React.FC<StatCardProps> = ({
  icon,
  value,
  label,
  highlight = false,
  onClick,
}) => {
  return (
    <div
      className={`stat-card ${highlight ? "highlight" : ""} ${onClick ? "clickable" : ""}`}
      onClick={onClick}
    >
      <div className="stat-content">
        <h3 className="stat-value">{value}</h3>
        <p className="stat-label">{label}</p>
      </div>
    </div>
  );
};

/** React component — Stat Card. */
export default StatCard;

